// src/portals/admin/components/monetization/DonationManager.js
import React, { useState } from "react";
import Button from "../../../../components/ui/Button";
import AdminDataTable from "../AdminDataTable";
import { Plus, Heart } from "lucide-react";
import { useData } from "../../../../context/DataContext";
import CreateOpportunityModal from "../CreateOpportunityModal";

const DonationManager = () => {
  const { donations, addDonationCause } = useData();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const donationColumns = [
    { header: "Cause / Organization", key: "title", render: (r) => <span className="font-medium text-slate-800">{r.title}</span> },
    { header: "Type", key: "category", render: (r) => <span className="text-sm text-slate-500 bg-slate-100 px-2 py-1 rounded">{r.category || "Charity"}</span> },
    { header: "Raised", key: "raised", render: (r) => <span className="font-medium text-green-600">{r.raised || "0 ETB"}</span> },
    { header: "Goal", key: "goal", render: (r) => <span className="text-slate-600">{r.goal || "No Goal"}</span> },
    { header: "Supporters", key: "supporters", render: (r) => <span className="px-2 py-1 bg-pink-50 text-pink-600 rounded-full text-xs">{r.supporters || 0} Creators</span> },
    { header: "Actions", key: "actions", render: () => <Button size="sm" variant="ghost">Edit</Button> }
  ];

  const handleCreate = (data) => {
    addDonationCause({
      id: Date.now(),
      title: data.title,
      description: data.description,
      category: "Emergency Relief", // Default for now
      imageUrl: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=100&h=100&fit=crop",
      raised: "0 ETB",
      supporters: 0,
      ...data
    });
    setIsModalOpen(false);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-bold text-slate-700">Donation Causes</h3>
        <Button onClick={() => setIsModalOpen(true)}><Plus className="w-4 h-4 mr-2" /> New Cause</Button>
      </div>
      
      <AdminDataTable 
        columns={donationColumns.map(c => ({...c, sortable: true}))} 
        data={donations}
        searchableFields={["title", "beneficiary"]}
        filterableFields={[
            { key: "category", label: "Category", options: ["Emergency Relief", "Education", "Health"] }
        ]}
      />

      {isModalOpen && (
        <CreateOpportunityModal 
          isOpen={isModalOpen} 
          onClose={() => setIsModalOpen(false)} 
          type="donation"
          onSave={handleCreate}
        />
      )}
    </div>
  );
};

export default DonationManager;
